import { useState, useMemo } from "react";

const SelfHeal = ({
  projects = [],
  selectedProjectIds = [],
  onToggle,
  loadingProjectIds = [],
}) => {
  const [open, setOpen] = useState(false);

  const selectedProjects = useMemo(() => {
    return projects.filter((project) =>
      selectedProjectIds.includes(project.project_id)
    );
  }, [projects, selectedProjectIds]);

  return (
    <div className="bg-gray-100 rounded-2xl p-8 border border-gray-200 min-w-0 max-w-full overflow-hidden">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800">
          Self Heal
        </h2>
        <p className="text-gray-600 mt-1">
          Automatically heal selected projects using AI configuration.
        </p>
      </div>

      {/* Card */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
        {/* Dropdown */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Select Projects
          </label>

          <div className="relative">
            <button
              onClick={() => setOpen((prev) => !prev)}
              className="w-full flex items-center justify-between px-4 py-2.5 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 transition focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <span className="text-gray-700">
                {selectedProjects.length > 0
                  ? `${selectedProjects.length} project(s) selected`
                  : "Select"}
              </span>

              <i
                className={`fas fa-chevron-down text-gray-500 transition-transform ${
                  open ? "rotate-180" : ""
                }`}
              />
            </button>

            {open && (
              <div className="absolute z-20 mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto p-3 space-y-2">
                {projects.map((project) => {
                  const isSelected = selectedProjectIds.includes(
                    project.project_id
                  );

                  const isLoading = loadingProjectIds.includes(
                    project.project_id
                  );

                  return (
                    <label
                      key={project.project_id}
                      className="flex items-center gap-3 px-2 py-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        disabled={isLoading}
                        onChange={() => onToggle(project)}
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700 truncate min-w-0" title={project.project_name}>
                        {project.project_name}
                      </span>

                      {isLoading && (
                        <span className="text-xs text-gray-400 ml-auto">
                          Updating...
                        </span>
                      )}
                    </label>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Selected Projects */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Selected Projects
          </label>

          {selectedProjects.length === 0 ? (
            <p className="text-sm text-gray-400">
              No projects selected
            </p>
          ) : (
            <div className="flex flex-wrap gap-2 min-w-0">
              {selectedProjects.map((project) => (
                <span
                  key={project.project_id}
                  className="max-w-full px-3 py-1 text-sm bg-blue-50 text-blue-700 border border-blue-100 rounded-md truncate"
                  title={project.project_name}
                >
                  {project.project_name}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelfHeal;